import { Link } from "react-router-dom";
import React from "react";
import PropTypes from 'prop-types';

const NavItemLink = ({ to, icon, alt }) => (
    <li className="nav-item">
        <Link className="nav-link p-0" to={to}>
          <img src={icon} alt={alt} />
        </Link>
    </li>
  );
  NavItemLink.propTypes = {
    to: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  };
  
  export default NavItemLink;